import PropTypes from "prop-types";
import styled, { css } from "styled-components";

export const IconSelectSD = styled.i`
  position: relative;
  display: inline-block;
  width: 6px;
  height: 8px;

  ${({ hiddenIcon }) =>
    !hiddenIcon &&
    css`
      &:before,
      &:after {
        content: "";
        position: absolute;
        border: 3px solid transparent;
        left: 0;
      }

      &:before {
        top: 0;
        border-bottom-color: #4dc3cf;
        border-top: none;
      }

      &:after {
        top: 5px;
        border-top-color: #4dc3cf;
        border-bottom: none;
      }
    `}
`;

IconSelectSD.propType = {
  hiddenIcon: PropTypes.bool
};
